export default __webpack_public_path__ + "static/media/no-presentation.95a7381d.png";